import * as React from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import Swal from 'sweetalert2'

import DialogTitle from '@mui/material/DialogTitle'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import apiInstance from '../../Utils/api'
export default function ImportDialog(props) {
    const [type, setType] = useState("")
    const [file, setFile] = useState("")
    console.log(file, 'file')

    const ImportCreate = () => {
        const formData = new FormData()
        formData.append("file", file)
        if (type === "product") {
            try {
                apiInstance.post(props.productUrl, formData).then(function (response) {
                    Swal.fire({
                        title: 'Successful!',
                        text: `Imported ${type} Data!`,
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    window.location.reload()


                })
            }

            catch (err) {
                Swal.fire({
                    title: 'Something Wrong!',
                    text: 'Error',
                    icon: 'warning',
                    showConfirmButton: false,
                    timer: 2000
                })
            }
        } else {
            try {
                apiInstance.post(props.itemUrl, formData).then(function (response) {
                    Swal.fire({
                        title: 'Successful!',
                        text: `Imported ${type} Data!`,
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    window.location.reload()


                })
            } catch (err) {
                Swal.fire({
                    title: 'Something Wrong!',
                    text: 'Error',
                    icon: 'warning',
                    showConfirmButton: false,
                    timer: 2000
                })
            }
        }

        props.setOpen(false)
    }


    return (
        <div>
            <Dialog open={props.open} onClose={props.close} fullWidth maxWidth='sm'>
                <DialogTitle>
                    <div className='modal-header bg-info'>
                        <h4 className='modal-title'>Import Excel File</h4>
                        <button
                            type='button'
                            className='close'
                            data-dismiss='modal'
                            aria-label='Close'
                            onClick={props.close}
                        >
                            <span aria-hidden='true'>&times;</span>
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText></DialogContentText>

                    {/* @csrf */}
                    <div class='modal-body'>
                        <div class='form-group'>
                            <label for='name'>Import Type</label>
                            <select
                                class='custom-select border-info'
                                name='account_type_id'
                                id='cat'
                                onChange={e => setType(e.target.value)}
                            >
                                <option hidden>Choose Type</option>
                                <option value="product">Product</option>
                                <option value="item">Item</option>

                            </select>
                        </div>
                        <div class='form-group'>
                            <label for='code'>Import File</label>
                            <input
                                type='file'
                                class='form-control border border-info'
                                name='code'
                                onChange={e => setFile(e.target.files[0])}
                            />
                        </div>

                    </div>
                    <div class='modal-footer'>
                        <Button
                            class='btn btn-secondary'
                            data-dismiss='modal'
                            onClick={props.close}
                        >
                            Close
                        </Button>
                        <Button class='btn btn-primary' onClick={ImportCreate}>
                            Import
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}
